module.exports = __webpack_public_path__ + "static/media/NHBCLogo.556b8a7b.png";